import { render, staticRenderFns } from "./Manga.vue?vue&type=template&id=e3cfa9ce&"
import script from "./Manga.vue?vue&type=script&lang=js&"
export * from "./Manga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports